var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    stroke: "#CFCFCF",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_13008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5384 8C12.6869 8 12.8294 8.059 12.9344 8.16402C13.0394 8.26904 13.0984 8.41148 13.0984 8.56V9.6072H19.112V8.5672C19.112 8.41868 19.171 8.27624 19.276 8.17122C19.381 8.0662 19.5235 8.0072 19.672 8.0072C19.8205 8.0072 19.963 8.0662 20.068 8.17122C20.173 8.27624 20.232 8.41868 20.232 8.5672V9.6072H22.4C22.8242 9.6072 23.2311 9.77566 23.5311 10.0755C23.8311 10.3754 23.9998 10.7822 24 11.2064V22.4008C23.9998 22.825 23.8311 23.2318 23.5311 23.5317C23.2311 23.8315 22.8242 24 22.4 24H9.6C9.17579 24 8.76895 23.8315 8.46891 23.5317C8.16888 23.2318 8.00021 22.825 8 22.4008V11.2064C8.00021 10.7822 8.16888 10.3754 8.46891 10.0755C8.76895 9.77566 9.17579 9.6072 9.6 9.6072H11.9784V8.5592C11.9786 8.41082 12.0377 8.26858 12.1427 8.16374C12.2477 8.05889 12.39 8 12.5384 8ZM9.12 14.1936V22.4008C9.12 22.4638 9.13242 22.5263 9.15654 22.5845C9.18066 22.6427 9.21602 22.6956 9.26059 22.7402C9.30516 22.7848 9.35808 22.8201 9.41631 22.8443C9.47455 22.8684 9.53697 22.8808 9.6 22.8808H22.4C22.463 22.8808 22.5255 22.8684 22.5837 22.8443C22.6419 22.8201 22.6948 22.7848 22.7394 22.7402C22.784 22.6956 22.8193 22.6427 22.8435 22.5845C22.8676 22.5263 22.88 22.4638 22.88 22.4008V14.2048L9.12 14.1936ZM13.3336 19.6952V21.028H12V19.6952H13.3336ZM16.6664 19.6952V21.028H15.3336V19.6952H16.6664ZM20 19.6952V21.028H18.6664V19.6952H20ZM13.3336 16.5136V17.8464H12V16.5136H13.3336ZM16.6664 16.5136V17.8464H15.3336V16.5136H16.6664ZM20 16.5136V17.8464H18.6664V16.5136H20ZM11.9784 10.7264H9.6C9.53697 10.7264 9.47455 10.7388 9.41631 10.7629C9.35808 10.7871 9.30516 10.8224 9.26059 10.867C9.21602 10.9116 9.18066 10.9645 9.15654 11.0227C9.13242 11.0809 9.12 11.1434 9.12 11.2064V13.0744L22.88 13.0856V11.2064C22.88 11.1434 22.8676 11.0809 22.8435 11.0227C22.8193 10.9645 22.784 10.9116 22.7394 10.867C22.6948 10.8224 22.6419 10.7871 22.5837 10.7629C22.5255 10.7388 22.463 10.7264 22.4 10.7264H20.232V11.4696C20.232 11.6181 20.173 11.7606 20.068 11.8656C19.963 11.9706 19.8205 12.0296 19.672 12.0296C19.5235 12.0296 19.381 11.9706 19.276 11.8656C19.171 11.7606 19.112 11.6181 19.112 11.4696V10.7264H13.0984V11.4624C13.0984 11.6109 13.0394 11.7534 12.9344 11.8584C12.8294 11.9634 12.6869 12.0224 12.5384 12.0224C12.3899 12.0224 12.2474 11.9634 12.1424 11.8584C12.0374 11.7534 11.9784 11.6109 11.9784 11.4624V10.7264Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_13008"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenIcon);
export default __webpack_public_path__ + "static/media/tokenIcon.bc3b93021ca5d20c9bb85976b6380175.svg";
export { ForwardRef as ReactComponent };